exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n", ""]);

// exports
exports.locals = {
	"darkestGrey": "#202020",
	"seafoam": "#52cab8",
	"denim": "#33495f",
	"liteGrey": "#f7f7f7",
	"midGrey": "#e5e5e5",
	"dkGrey": "#979797",
	"linkblue": "#1192ff",
	"errorRed": "#d0021b",
	"hoverSeafoam": "#39B19F",
	"brandBlue": "#1281E0",
	"brandBlueHover": "#0068C7",
	"seafoamTranslucent": "rgba(82,202,184,0.4)",
	"greyTransparent": "rgba(100,100,100,0.6)",
	"alertYellow": "#fff1d7",
	"alertBorder": "#ffbb38"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]_[local]_[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/styleColors.css
// module id = 0
// module chunks = 0